import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ChatWidgetInputBase } from '../chat-widget-input-base';

const CVV_PATTERN = /^\d{3,4}$/;

/**
 * Renders the card CVV widget inside the chat widget for an Individual Credit
 * Card item that needs one. The digits are emitted once and never kept on the
 * widget after submission, so a locked (superseded) instance shows an empty
 * disabled field.
 */
@Component({
  selector: 'app-chat-cvv-input',
  standalone: false,
  templateUrl: './chat-cvv-input.component.html',
  styleUrls: ['./chat-cvv-input.component.scss']
})
export class ChatCvvInputComponent extends ChatWidgetInputBase implements OnChanges {
  @Input() required = true;
  @Output() answer = new EventEmitter<string>();
  @Output() skip = new EventEmitter<void>();

  cvv = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (this.onlyLockedChanged(changes)) {
      return;
    }
    this.cvv = '';
  }

  get isMandatory(): boolean {
    return this.required === true;
  }

  get isValid(): boolean {
    return CVV_PATTERN.test(this.cvv.trim());
  }

  onContinue(): void {
    if (this.locked || !this.isValid) {
      return;
    }
    const cvv = this.cvv.trim();
    this.cvv = '';
    this.answer.emit(cvv);
  }

  onSkip(): void {
    if (this.locked) {
      return;
    }
    this.skip.emit();
  }
}
